import { render } from "./AccountPage.vue?vue&type=template&id=6bf999dd&scoped=true"
import script from "./AccountPage.vue?vue&type=script&lang=js"
export * from "./AccountPage.vue?vue&type=script&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=6bf999dd&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf999dd"]])

export default __exports__